import {
  AnalyticsFragment,
  MyVaroSectionTileFragment,
} from 'services/graphql/fragments/VxlFragments';
import { gql } from 'urql';

const MyVaroPageTiles = gql`
  query myVaroPageTiles {
    myVaroPageTile(
      input: {
        tileType: [MY_VARO_PAGE_TILE, MY_VARO_SECTION_TILE, MY_VARO_VXL_TILE]
      }
    ) {
      __typename
      id
      status
      tileType
      displayAnalytics {
        ...analytics
      }
      tiles {
        __typename
        id
        status
        tileType
        ...MyVaroSectionTileFragment
      }
    }
  }
  ${AnalyticsFragment}
  ${MyVaroSectionTileFragment}
`;

export default MyVaroPageTiles;
